var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('common-header'),_c('div',{staticClass:"container-main",class:[
      !_vm.supportSafeAreaLandscape ? 'page-not-support-safearea' : false,
      _vm.$platformClass ]},[_vm._t("default")],2),_c('transition',[(_vm.maskShow)?_c('div',{staticClass:"container-mask",on:{"click":_vm.toggleMask}}):_vm._e()]),_c('toast'),_c('image-preview')],1)}
var staticRenderFns = []

export { render, staticRenderFns }